module.exports = __webpack_public_path__ + "img/technology-2.b8b24d80.png";